import React, { useEffect, useState } from 'react';
import {AiFillGithub} from 'react-icons/ai'
import './styles/projects.css';
import axios from 'axios';


const Project = (props)=>{
    function Mouseover() {
        document.getElementById("projId"+props.record.projName).style.backgroundImage = "url("+props.record.projImg+")";
    }
    function Mouseout() {
        document.getElementById("projId"+props.record.projName).style.backgroundImage = "";
    }

    return(
        <div id={"projId"+props.record.projName} className='project' onMouseOver={Mouseover} onMouseOut={Mouseout}>
            <div className='projHead'>
                {props.record.projName}
            </div>
            <div className='projBody'>
                <p><span>{props.record.projTime}</span>
                    {props.record.projDesc}
                </p>
            </div>
            <div className='projFoot'>
                <a href={props.record.projLink}><AiFillGithub size={"30px"}/> GitHub</a>
            </div>
        </div>
    )
}

export default function Projects(){

    const [Projs,setProjs] = useState({"records": []});

    useEffect(()=>{
        axios
            .get("https://myportfolioapp-server.herokuapp.com/record/")
            .then((res)=>{
                setProjs({"records": res.data});
            })
            .catch((err)=>{
                console.log(err);
            });
    });


    return(
        <div className='projects'>
            {
                Projs["records"].map((key,i)=>{
                    return(
                        <Project key={i} record={key}/>
                    )
                })
            }
        </div>
    );
}